import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getStoredTokens } from '../services/authService';

export const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const { accessToken } = getStoredTokens();
    const location = useLocation();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user && !accessToken) {
        // Redirect to login page but save the attempted url
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}; 